import React from "react";
import { NavLink } from "react-router-dom";
import {
  IoSettingsOutline,
  IoReceiptOutline,
  IoPersonOutline,
} from "react-icons/io5";
import { SlCalender } from "react-icons/sl";
import { MdOutlineDashboard } from "react-icons/md";
import { motion } from "framer-motion";

function Admin() {
  const navLinks = [
    {
      name: "Dashboard",
      link: "/admin/dashboard",
      icon: <MdOutlineDashboard className="mr-2" />,
    },
    {
      name: "Employees",
      link: "/admin/employees",
      icon: <IoPersonOutline className="mr-2" />,
    },
    {
      name: "Attendance",
      link: "/admin/attendance",
      icon: <IoReceiptOutline className="mr-2" />,
    },
    {
      name: "Events",
      link: "/admin/events",
      icon: <SlCalender className="mr-2" />,
    },
    {
      name: "Settings",
      link: "/admin/settings",
      icon: <IoSettingsOutline className="mr-2" />,
    },
  ];

  return (
    <motion.div
      transition={{ type: "spring", stiffness: 100, damping: 15 }}
      className="h-full w-72 bg-slate-800 rounded-xl flex flex-col items-center p-5"
    >
      <motion.h1
        transition={{ delay: 0.3 }}
        className="w-full h-12 flex justify-center items-center cursor-pointer text-2xl text-red-100"
      >
        <NavLink to="/">Admin Panel</NavLink>
      </motion.h1>

      <div className="gap-6 flex flex-col items-start text-xl w-full mt-10">
        {navLinks.map((item, index) => (
          <motion.div
            key={index}
            whileHover={{ scale: 1.05 }}
            transition={{
              type: "spring",
              stiffness: 300,
              delay: 0 + index * 0.1,
            }}
            whileTap={{ scale: 0.95 }}
            className="w-full"
          >
            <NavLink
              to={item.link}
              className={({ isActive }) =>
                `text-slate-200 w-full hover:bg-opacity-50 hover:bg-slate-300 hover:shadow-md h-12 flex justify-start items-center cursor-pointer pr-8 pl-8 rounded-full ${
                  isActive ? "bg-slate-500" : "hover:bg-slate-900"
                }`
              }
            >
              {item.icon} {item.name}
            </NavLink>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}

export default Admin;
